<template>
  <Page class="page-rnr-person-base">
    <template #slot-title>
      <span>{{ currentFlow }}/{{ totalFlow }}</span>
      <span>代办人身份信息</span>
    </template>
    <UserInfo :value="formData" ref="userRef" :cert-type="personRnr.consignerInfo ? personRnr.consignerInfo.certType : ''" :show-phone="personRnr.isConsigner" type="bluetooth" @formFill="formFill"/>
    <template slot="slot-operation">
      <van-button class="page-rnr-main-btn-before lastStep" round @click="handleToBefore">上一步</van-button>
      <van-button type="primary" :disabled="disabled" class="page-rnr-main-btn-next" round color="linear-gradient(120deg, #000 0%, #000 97%)" @click="handleToNext">下一步</van-button>
    </template>
  </Page>
</template>

<script>
import { mapGetters } from 'vuex'
import Page from '@/components/Page'
import UserInfo from '@/components/UserInfo'
import flowMixin from '@/minxin/flow'
import { SET_PERSON_CONSIGNER_CARD } from '@/store/modules/rnr'
import { checkPersonInfoWithOcr } from '@/api/rnr'

export default {
  name: 'RnrPersonConsignerBase',
  components: { Page, UserInfo },
  mixins: [flowMixin],
  data() {
    return {
      isConnect: false,
      formData: {
        certAddress: '',
        certExpirationDate: '',
        certNumber: '',
        certType: 'IDCARD',
        contactAddress: '',
        fullName: '',
        gender: ''
      },
      disabled: true
    }
  },
  computed: {
    ...mapGetters(['isNFCDevice', 'personRnr'])
  },
  methods: {
    formFill(val) {
      if (!val.hasOwnProperty('phone')) {
        if (val.certAddress && val.certExpirationDate && val.certNumber && val.fullName && val.gender) {
          this.disabled = false
        } else {
          this.disabled = true
        }
      } else {
        if (val.certAddress && val.certExpirationDate && val.certNumber && val.fullName && val.gender && val.phone) {
          this.disabled = false
        } else {
          this.disabled = true
        }
      }
    },
    /**
     * 调到到下一页：腾讯的实名认证平台
     */
    async handleToNext() {
      // 校验不通过的字段
      try {
        const formData = this.$refs.userRef.validate()
        // 将当前数据保存到store中
        this.$store.commit(`rnr/${SET_PERSON_CONSIGNER_CARD}`, formData)

        const rnrInfo = this.$store.getters.personRnr
        // 额外送到后台进行OCR校验
        await checkPersonInfoWithOcr(rnrInfo)

        // 跳转到文件上传页
        this.routerToNextPage('RnrPersonFile')
      } catch (error) {
        console.error('校验失败：', error)
      }
    },

    /**
     * 跳转到上一页
     */
    handleToBefore() {
      // 回退到上个页面
      this.$router.back()
    }
  }
}
</script>

<style lang="scss">
.page-rnr-person-base {
  .page-rnr-main-card {
    .page-rnr-person-base-icon-idcard-reader {
      background-image: url(../../../assets/rnr/ico_idcard_reader.png);
      background-size: 100% 100%;
      width: 654px;
      height: 272px;
      margin: 0 auto;
    }
    .page-rnr-person-base-step {
      color: #242424;
      font-size: 24px;
      text-align: center;
      font-weight: 400;
      line-height: 34px;
      margin-top: 10px;
      &:first-child {
        margin-top: 20px;
      }
    }
    .page-rnr-person-base-btn-wrap {
      margin-top: 56px;
      .van-button {
        font-size: 30px;
        .page-rnr-person-base-icon-bluetooth {
          background-image: url(../../../assets/rnr/ico_bluetooth.png);
          background-size: 100% 100%;
          display: inline-block;
          width: 30px;
          height: 30px;
          margin-right: 12px;
          margin-bottom: -4px;
        }
      }
      .page-rnr-person-base-btn-block {
        align-items: center;
        border-radius: 50%;
        color: #0761F3;
        display: flex;
        font-size: 30px;
        height: 88px;
        justify-content: center;
        margin-top: 24px;
        .page-rnr-person-base-icon-switch {
          background-image: url(../../../assets/rnr/ico_switch.png);
          background-size: 100% 100%;
          display: inline-block;
          width: 30px;
          height: 30px;
          margin-right: 12px;
          margin-bottom: -4px;
        }
      }
    }
    &.base-intro {
      padding: 26px 24px 40px !important;
    }
  }
  .page-rnr-main-fixed-btn-group {
    display: flex;
    justify-content: space-between;
    .page-rnr-main-btn-before {
      color: #242424 !important;
      flex: 1;
      height: 96px;
    }
    .page-rnr-main-btn-next {
      flex: 2;
      margin-left: 40px;
      height: 96px;
    }
  }
  .van-cell__label {
    .page-rnr-flex {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/rnr/person/consigner-base.vue